/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UpdateErrorReason {
    Ok = 0,
    Exception = 100,
    ConfigurationNotFound = 101,
    TrainingRoomNotFound = 102,
    NoTrainingRooms = 103,
    CameraNotFound = 104,
    NotEnoughCameras = 105,
    CameraInUseOnRecording = 106,
    VopAlreadyUsed = 201,
    VogAlreadyUsed = 202,
    VttAlreadyUsed = 203,
}
